import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    letterSpacing: 0,
    color: "#000000",
    marginTop: "32px",
  },

  mobile_container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    letterSpacing: 0,
    color: "#000000",
    marginTop: "32px",
    padding: "0px 20px",
  },

  title: {
    fontSize: "35px",
    marginBottom: "60px",
  },

  mobile_title: {
    fontSize: "26px",
    marginBottom: "24px",
    fontWeight: "bold",
  },

  tabs_container: {
    marginBottom: "48px",
  },

  mobile_tabs_container: {
    marginBottom: "24px",
  },

  inputs_container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    gap: "44px",
  },

  mobile_inputs_container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    gap: "24px",
  },

  inputs_firstRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "100px",
  },

  mobile_inputs_firstRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "16px",
    flexDirection: "column",
  },

  inputs_secondRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "100px",
  },

  mobile_inputs_secondRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "16px",
    flexDirection: "column",
  },

  inputs_thirdRow: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
    gap: "100px",
  },

  mobile_inputs_thirdRow: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
    gap: "16px",
    flexDirection: "column",
  },

  inputWrapper: {
    width: "100%",
    marginBottom: "8px",
  },

  inputSingleWrapper: {
    width: "45%",
    marginBottom: "8px",
  },

  mobile_inputSingleWrapper: {
    width: "100%",
    marginBottom: "8px",
  },

  button_container: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "100%",
    margin: "48px 0px",
  },

  message: {
    marginTop: 24,
    [theme.breakpoints.down("desktop")]: {
      marginTop: 28,
    },
  },

  // -------------------------------------- Second Page---------------------------------//

  input_container: {
    width: "100%",
    marginBottom: "46px",
  },

  uncoatedArray_container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px",
  },

  mobile_uncoatedArray_container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "16px",
    marginBottom: "20px",
  },
  helperText: {
    color: "#000",
  },
}));

export default useStyles;
